import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { h5PageCount } from 'ThreeTerminal_utils';
import { QQShare } from 'ThreeTerminal_mobile_dynamic';
import Header from './header';
import BigVideo from './bigVideo';
import RelateVideo from './relateVideo';
import OpenAppButton from './openAppButton';
import styles from './index.css';

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
        const {
            content: {
                docData: { base62Id },
                videoInfo: { guid },
                isShare,
                isVideoShare,
                readNumConfig,
            },
        } = this.props;

        // 手凤不发送page统计
        // if (isShare) {
        // 页面统计
        h5PageCount([
            {
                datatype: isVideoShare ? 'vappsns_ex' : 'newsappsns',
                behavior: 'page',
                type: 'sv',
                other: {
                    id: `sv_${base62Id}`,
                    ref: encodeURIComponent(document.referrer),
                    url: encodeURIComponent(location.href),
                },
            },
        ]);
        // }
    }

    render() {
        const {
            content: {
                isVideoShare,
                _id,
                headKeyword,
                commentUrl,
                docData,
                aspect,
                docData: { base62Id, subscribe, miniVideoPoster },
                videoInfo: { title, sharePosterUrl, bigPosterUrl, mobileUrl, guid, columnName, desc },
                readNumConfig,
                hasCopyRight,
                publishedTime,
                searchPath,
                wemediaEAccountId,
                safeLevel,
                interact,
                isCloseAlgRec,
            },
        } = this.props;
        const headerData = {
            ...docData,
            isVideoShare,
            _id,
            headKeyword,
        };
        const qqShareCofig = {
            title,
            img: sharePosterUrl || 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
            desc: '',
            appType: isVideoShare ? 'videoApp' : 'newsApp',
            cb: () => {},
        };
        const bigVideoData = {
            bigPosterUrl: miniVideoPoster || bigPosterUrl,
            mobileUrl,
            base62Id,
            isVideoShare,
            guid,
            _id,
            columnName,
            desc,
            logo: subscribe.logo || '',
            commentUrl,
            aspect,
            readNumConfig,
            hasCopyRight,
            publishedTime,
            searchPath,
            wemediaEAccountId,
            safeLevel,
            interact,
        };
        const relateVideoData = {
            base62Id,
        };
        const openAppButtonData = {
            _id,
        };

        const isHitBlack = safeLevel === 1;

        return (
            <Fragment>
                <Header content={headerData} />
                <BigVideo content={bigVideoData} />
                {!isHitBlack && !isCloseAlgRec && <RelateVideo content={relateVideoData} />}
                <OpenAppButton content={openAppButtonData} />
                {qqShareCofig.title && <QQShare content={qqShareCofig} />}
            </Fragment>
        );
    }
}

export default errorBoundary(Layout);
